import { combineReducers, Reducer, UnknownAction } from "redux";
import user from "./user/reducers";
import { IStateTree } from "./interfaces";
import packs from "./dashboard/reducers";
import pack from "./pack/reducers";
import plan from "./plan/reducers";
import teacher from "./teacher/reducers";
import recentPlans from "./recentPlans/reducers";
import browse from "./browse/reducers";
import notifications from "./notification/reducers";
import webp from "./webp/reducers";
import darkMode from "./darkMode/reducers";
import cookieAccepted from "./cookieAccepted/reducers";
import testModeration from "./testModeration/reducers";

// Named rather than inferred: redux 5 works the preloaded state's shape out from the
// reducers, and only from ones that accept any action - ours are written against their
// own action union, which is the point of having them.
export default () => combineReducers({
    user,
    packs,
    pack,
    plan,
    recentPlans,
    teacher,
    browse,
    notifications,
    webp,
    darkMode,
    cookieAccepted,
    testModeration,
}) as Reducer<IStateTree, UnknownAction, Partial<IStateTree>>;
